import { Banner } from "@components/Banner";
import { Header2 } from "@components/foundation/Header2";
import Rulers from "components/dev/Rulers";
import {
  TitleAndMetaTags,
  TitleAndMetaTagsProps,
} from "components/TitleAndMetaTags";
import { useState } from "react";
import { Footer } from "./Footer";
import { Header } from "./Header";

type LayoutProps =
  | {
      banner?: React.ReactNode;
    } & (TitleAndMetaTagsProps | { noTags: true });

const Layout = (props: React.PropsWithChildren<LayoutProps>) => {
  const [bannerOpen, setBannerOpen] = useState(true);
  return (
    <div>
      {/* <Rulers /> */}
      {"noTags" in props ? null : <TitleAndMetaTags {...props} />}
      {/* <Banner open={bannerOpen} setOpen={setBannerOpen} /> */}

      <Header2 />
      {props.children}
      <Footer />
    </div>
  );
};

export default Layout;
